import { gql } from "@apollo/client";

export const UpdateInstalledBaseNode = gql`
    mutation UpdateInstalledBaseNode (
        $id: ID!,
        $input: InstalledBaseNodeUpdateAttributesInput!,
        $attributes: [InstalledBaseCustomAttributeInput!]
    ){
        updateInstalledBaseNode(
            id: $id,
            input: $input,
            attributes: $attributes
        ){
            id
            key
            keyPath
            title
            image {
                id
                file {
                    id
                }
            }
        }
    }
`;
